import React, { useRef } from "react";
import { useEffect, useState } from "react";
import "../Products/product.css";
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import ion_cart_outline from "../../Assets/Images//ion_cart-outline.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../Services/axios";
import { LiaPlusCircleSolid } from "react-icons/lia";
import { FiMinusCircle } from "react-icons/fi";
import { RxHamburgerMenu } from "react-icons/rx";
import "bootstrap/dist/css/bootstrap.min.css";
import { IoSearch } from "react-icons/io5";
import defaultimg from "../../Assets/Images/default-placeholder.png";
import { toast } from "react-toastify";
import { BsChevronDown } from "react-icons/bs";
import { IoIosArrowUp } from "react-icons/io";
import { IoChevronDown } from "react-icons/io5";
import vegIcon from "../../Assets/Images/vegpngoutput.png"
import nonvegIcon from "../../Assets/Images/nomvegoutput.png"
import eggIcon from "../../Assets/Images/eggpngoutput.png"
import Toggle from "../../Components/toggle-button/Toggle";
import { FaRupeeSign } from "react-icons/fa";
import Lottie from "lottie-react";
import empotyLottie from "../../Assets/lottieFiles/emptybox.json"
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { showToast } from "../../Components/toastConfig/ToastConfig";
import { CgClose } from "react-icons/cg";
import { FaRegSquare, FaSquareCheck } from "react-icons/fa6";
import { IoIosArrowDown } from "react-icons/io";
import ProductCard from "../../Components/productCard/productCard";
import NodeaxiosInstance from "../../Services/nodeaxios";
import { addOrRemoveProductCart, fetchVendorProductCategoriesList, getVendorProfileDetails, vendorProductsAddonList, vendorProductsList } from "../../Services/api";
const Products = () => {
  const navigate = useNavigate();

  const addonModalRef = useRef(null);
  const addonEditeModalRef = useRef(null);

  const [cartId, setCartId] = useState("");
  const [cardCount, setCardCount] = useState();
  const [shipingtype, setShipingtype] = useState("");
  const valueParam = useParams();
  const merchantId = valueParam.vendor_id;

  const [isModelOpen, setModelOpen] = useState(false);
  const [isMenuOpen, setMenuOpen] = useState(true);
  const [showMenus, setShowMenus] = useState(false);
  const [searchitem, setSearchitem] = useState("");
  const [searhModelItems, setSearhModelItems] = useState([]);
  const [loadingButtonId, setLoadingButtonId] = useState(null);
  const [pageLoaded, setPageLoaded] = useState(false);

  const [selectItem, setSelectItem] = useState('')
  const [openIndices, setOpenIndices] = useState([0]);
  // Offer or Membership
  const [cardStatus, setCardStatus] = useState();
  const [cardType, setcardType] = useState();
  const [cardId, setcardId] = useState();
  // Food menu 
  const [isVegSelected, setIsVegSelected] = useState(false);
  const [isNonVegSelected, setIsNonVegSelected] = useState(false);
  const [isEggSelected, setIsEggSelected] = useState(false);

  const [productlistRaw, setProductlistRaw] = useState('')

  const [productid, setProductid] = useState('')
  const [productCost, setProductCost] = useState('')
  const [addonsCost, setAddonsCost] = useState('')
  const [selectedAddons, setSelectedAddons] = useState([])
  const [productCount, setProductCount] = useState(0);
  const [cartproduct, setCartproduct] = useState([])

  const [card, setCard] = useState("")
  const [filteredItems, setFilteredItems] = useState([]);

  const location = useLocation();
  const { flowtype } = location.state || {};
  const [productsCategories, setProductsCategories] = useState()
  const [productsList, setProductsList] = useState([])
  const [allProductsList, setAllProductsList] = useState([])
  const [productsAddons, setProductsAddons] = useState()
  const [cardDetails, setCardDetails] = useState()
  const [vendorType, setVendorType] = useState()
  const [mergedProductsRaw, setMergedProductsRaw] = useState([])
  const [mergedProducts, setMergedProducts] = useState()
  const [TotalPagesCount, setTotalPagesCount] = useState()
  const [MenuLoaded, setMenuLoaded] = useState()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [serarchModal, setSerarchModal] = useState(false)

  const [totalproductCount, setTotalproductCount] = useState()
  const [productpriceTotal, setProductpriceTotal] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0)
  const [btnLoading, setBtnLoading] = useState(false)


  const closeMenuList = (event) => {
    const menuButton = document.getElementById("menuButton");
    if (menuButton && !menuButton.contains(event.target)) {
      setShowMenus(false);
    }
  };

  useEffect(() => {
    filterFoodProducts()
  }, [isNonVegSelected, isVegSelected, isEggSelected]);

  useEffect(() => {
    setOpenIndices(mergedProducts?.map((_, index) => index));
  }, [mergedProducts]);


  useEffect(() => {
    let productCart = localStorage.getItem("productCart") ? JSON.parse(localStorage.getItem("productCart")) : "";
    const localCartId = productCart?.cartId || "";
    let Cart = localStorage.getItem("cartid") ? JSON.parse(localStorage.getItem("cartid")) : "";

    setCartId(localCartId || Cart);

    setShipingtype(productCart?.shipping_type || '');

    let appliedCard = JSON.parse(localStorage.getItem("appliedCard"));
    const localCardId = appliedCard?.cardId || "";
    const localCardStatus = appliedCard?.cardStatus || "";
    const localCardType = appliedCard?.cardType || "";

    setCardStatus(localCardStatus);
    setcardType(localCardType);
    setcardId(localCardId);


    let cart_items = localStorage.getItem("cart_items") ? JSON.parse(localStorage.getItem("cart_items")) : "";
    const localcart_items = cart_items?.cart_items || "";
    setCartproduct(Array.isArray(localcart_items) ? localcart_items : []);


    setCardCount(cart_items?.cart_count);

    // if (cart_items?.cart_items?.length > 0) {
    //   const totalCount = cartData.cart_items.reduce(
    //     (acc, item) => acc + Number(item.quantity),
    //     0
    //   );
    //   setTotalproductCount(totalCount);
    // }

    if (cart_items?.cart_items?.length > 0) {
      const totalCount = cart_items?.cart_items.reduce((acc, item) => acc + Number(item.quantity), 0)
      setTotalproductCount(totalCount)

    }
    setTotalAmount(cart_items?.sub_total)

    if (cart_items?.cart_count && cart_items.cart_count != 0) {
      setModelOpen(true);
    }

  }, [mergedProducts, shipingtype, valueParam?.vendor_id]);



  useEffect(() => {
    if (cartId != "") {
      getproductlist();
    }

  }, [cartId]);

  useEffect(() => {
    if (flowtype) {
      let EditCart = localStorage.getItem("EditOrder_Detail") ? JSON.parse(localStorage.getItem("EditOrder_Detail")) : "";
      if (EditCart) {
        setCartId(EditCart?.orderid ? EditCart?.orderid : "");
        setShipingtype(EditCart?.shippingtype ? EditCart?.shippingtype : "");
      }
    }
  }, [flowtype]);



  const getproductlist = () => {
    try {

      let reqData = {
        vendor_id: valueParam.vendor_id,
        shipping_type: shipingtype,
        cart_id: cartId,
        card_status: cardStatus,
        card_type: cardType,
        card_id: cardId,
        flow_type: flowtype == "EDIT_ORDER" ? "EDIT_ORDER" : "ORDER"
      };

      NodeaxiosInstance.post("product/vendor-products-list", reqData)
        .then((res) => {
          if (res.status == 200) {
            let data = res.data;

            setProductlistRaw(data?.result);
            // setProductlist(data?.result);
            // if (data?.cart_count) {
            //   setCardCount(data?.cart_count);

            // } 

            // setPageLoaded(true); 
            // setCard(data?.card)

          }
        })
        .catch((err) => {
          if (err.response.status == 400 || err.response.status == 500) {
            showToast(err.response.data.message || "Something went wrong. Please try again.");
          }
        });
    } catch (error) {
      showToast("Something went wrong. Please try again.");
    }
  };

  const handleClick = (buttonId, item) => {
    setLoadingButtonId(buttonId);
    setModelOpen(true)
    setProductid(buttonId)
    // action_productcount(item, "add")
    Add_Remove_productcount(item, 'add', 1)
  };

  const selectAddon = (addon, option, price, options) => {
    let addonId = addon.addon_id;
    let selectedAddonsList = [...selectedAddons];
    let found = false;


    selectedAddonsList.forEach(item => {
      if (item.addonId == addonId) {
        found = true;
        const existingOption = item.options.find(opt => opt.optionId === option);
        if (!existingOption) {
          if ((addon.selection_type == 1 && item.options.length > 0) ||
            (addon.selection_type == 2 && Number(addon.max_select) > 0 && item.options.length >= Number(addon.max_select))) {
            toast("You have already selected max addons for this category", {
              position: "bottom-center",
              autoClose: 2000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false,
              progress: undefined,
              theme: "light",
              className: "text-danger toast-style-1",
            });
          } else {
            item.options.push({ optionId: option, name: options.name, type: options.type, price: price, });
            setProductCost(Number(productCost) + Number(price));
            setAddonsCost(Number(addonsCost) + Number(price));

          }
        } else {
          item.options = item.options.filter(opt => opt.optionId !== option);
          setProductCost(Number(productCost) - Number(price));
          setAddonsCost(Number(addonsCost) - Number(price));
        }
      }
    });

    if (!found) {
      selectedAddonsList.push({
        addonId: addonId,
        product_id: addon.product_id,
        options: [{ optionId: option, name: options.name, type: options.type, price: price, },]
      });
      // selectedAddonsList.push({ "addonId": addonId, "options": [option] });

      setProductCost(Number(productCost) + Number(price));
      setAddonsCost(Number(addonsCost) + Number(price));
    }

    setSelectedAddons(selectedAddonsList);
  };

  let globalCartId = null;
  const Add_Remove_productcount = async (item, action, addCount) => {


    try {
      const Addition = selectedAddons.reduce((acc, addon) => {
        if (addon.product_id == item.product_id && addon.options && Array.isArray(addon.options)) {
          acc.push(...addon.options.map(option => option.optionId));
        }
        return acc;
      }, []);


      let productCart = localStorage.getItem("productCart") ? JSON.parse(localStorage.getItem("productCart")) : "";
      let cart_items = localStorage.getItem("cart_items") ? JSON.parse(localStorage.getItem("cart_items")) : "";
      let localcart_items = cart_items.cart_items;


      let counts = 0;
      let quantityToSend = 1;

      if (localcart_items) {
        const productInCart = localcart_items.find(
          (cartItem) => cartItem.product_id == item.product_id
        );
        if (productInCart) {
          counts = productInCart.quantity;
        }
      }

      if (productCount) {
        quantityToSend = productCount - counts;
      } else {
        quantityToSend = 1;
      }



      let reqData = {
        vendor_id: valueParam.vendor_id,
        product_id: item.product_id,
        shipping_type: shipingtype,
        cart_id: productCart.cartId ? productCart.cartId : globalCartId,
        quantity: addCount ? addCount : quantityToSend,
        operation: action,
        card_status: cardStatus,
        card_type: cardType,
        card_id: cardId,
        addons: Addition.length > 0 ? Addition : "",
        flow_type: flowtype == "EDIT_ORDER" ? "EDIT_ORDER" : "ORDER"
      };



      const res = await addOrRemoveProductCart(reqData);

      if (res.status == 200) {
        if (!globalCartId) {
          globalCartId = res.data.cart_id;
          localStorage.setItem("cartid", JSON.stringify(globalCartId));
        }

        setCardCount(res.data.cart_count);
        if (res.data.cart_items?.length > 0) {
          const totalCount = res.data.cart_items.reduce((acc, item) => acc + Number(item.quantity), 0)
          setTotalproductCount(totalCount)
        }
        // setTotalproductCount(res.data.cart_items.length)
        setTotalAmount(res.data.sub_total)


        let productCart = {
          shipping_type: shipingtype,
          cartId: globalCartId,
          vendorId: valueParam.vendor_id
        };
        localStorage.setItem("productCart", JSON.stringify(productCart));

        const cartItemsFromAPI = res?.data?.cart_items || [];

        const updatedCartItems = cartItemsFromAPI.map(item => ({
          ...item,
          price: productCost,
        }));
        const cart_items = {
          cart_items: updatedCartItems,
          cart_id: res?.data?.cart_id,
          cart_count: updatedCartItems.length,
          sub_total: res?.data?.sub_total,
        };

        localStorage.setItem("cart_items", JSON.stringify(cart_items));


        setCartId(globalCartId);
        let newcart_items = localStorage.getItem("cart_items") ? JSON.parse(localStorage.getItem("cart_items")) : "";
        let localcart_items = newcart_items.cart_items;
        setCartproduct(localcart_items);
        getproductlist();

        // Handle modal logic based on addonstate
        // if (addonstate == "0") {
        //   setModelOpen(true);
        // }

        setSelectedAddons([]);
      }
    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      } else {
        showToast("Can't select product. Please contact support or try again later.");
      }
    }
  };


  function openserachProductModal() {
    setSerarchModal(true);
    setMenuOpen(false);
    closeAddonModal();
    closeEditAddonModal();
    setIsModalOpen(true);
  }

  function closeserachProductModal() {
    setSerarchModal(false);
    setMenuOpen(true);
    setIsModalOpen(false);
    // setIsVegSelected(false);
    // setIsNonVegSelected(false);
  }

  const toggleAccordion = (index) => {
    if (openIndices.includes(index)) {
      setOpenIndices(openIndices.filter((i) => i !== index));
    } else {
      setOpenIndices([...openIndices, index]);
    }
  };


  const isItemOpen = (index) => openIndices.includes(index);

  useEffect(() => {
    filterProducts()

  }, [isVegSelected, isNonVegSelected, isEggSelected])

  const filterProducts = () => {
    let filteredData = mergedProductsRaw;

    if (isVegSelected) {
      filteredData = mergedProductsRaw.map((category) => {
        return {
          ...category,
          products: category.products.filter((product) =>
            isEggSelected ? product.food_type == 1 || product.food_type == 3 : product.food_type == 1
          ),
        };
      }).filter((category) => category.products.length > 0);
    }
    else if (isNonVegSelected) {
      filteredData = mergedProductsRaw.map((category) => {
        return {
          ...category,
          products: category.products.filter((product) => product.food_type == 2 || product.food_type == 3),
        };
      }).filter((category) => category.products.length > 0);
    }

    else {
      filteredData = mergedProductsRaw;
    }

    setMergedProducts(filteredData);
  };


  const handleVegToggle = () => {
    setIsVegSelected(!isVegSelected);
    if (!isVegSelected) {
      setIsNonVegSelected(false);
      setIsEggSelected(false)
    }
  };
  const handleNonVegToggle = () => {
    setIsNonVegSelected(!isNonVegSelected);
    if (!isNonVegSelected) {
      setIsVegSelected(false);
    }
  };

  // const handleEggToggle = () => {
  //   setIsEggSelected(!isEggSelected);
  // };

  const handleEggToggle = () => {
    if (isVegSelected) {
      setIsEggSelected(prevState => !prevState);
    }
  };

  const dropUpMenuPress = () => {
    setShowMenus((prevShowMenus) => {
      const newState = !prevShowMenus;
      return newState;
    });
  };

  const handleCategoryClick = (index) => {

    const accordionItem = document.getElementById(`collapseOne${index}`);

    if (!openIndices.includes(index)) {
      setOpenIndices([...openIndices, index]);
    }

    if (accordionItem) {
      accordionItem.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const filterFoodProducts = () => {
    let filteredList = allProductsList;

    if (isVegSelected) {
      if (isEggSelected) {
        filteredList = allProductsList?.filter((product) => product.food_type == 1 || product.food_type == 3)

      } else {
        filteredList = allProductsList?.filter((product) => product.food_type == 1)
      }
    } else if (isNonVegSelected) {
      filteredList = allProductsList?.filter((product) => product.food_type == 2 || product.food_type == 3)
    }
    setFilteredItems(filteredList)
  }

  // useEffect(() => {
  //   const search = typeof searchitem === "string" ? searchitem.toLowerCase() : "";

  //   const updatedList = allProductsList.filter((item) => {
  //     const hasValidProductName = typeof item.product_name === "string";
  //     const hasValidProductCategory = typeof item.category_name === "string";

  //     const productNameMatches =
  //       hasValidProductName && item.product_name.toLowerCase().includes(search);
  //     const productCategoryMatches =
  //       hasValidProductCategory && item.category_name.toLowerCase().includes(search);

  //     return productNameMatches || productCategoryMatches;
  //   });

  //   setFilteredItems(updatedList);
  // }, [searchitem, allProductsList]);

  useEffect(() => {
    const search = typeof searchitem === "string"
      ? searchitem.toLowerCase()
      : "";

    let filteredList = allProductsList?.filter((item) => {

      //  Search Match
      const productNameMatches =
        typeof item.product_name === "string" &&
        item.product_name.toLowerCase().includes(search);

      const categoryMatches =
        typeof item.category_name === "string" &&
        item.category_name.toLowerCase().includes(search);

      const searchMatches = productNameMatches || categoryMatches;

      //  Food Type Match
      let foodTypeMatches = true;

      if (isVegSelected) {
        foodTypeMatches = isEggSelected
          ? item.food_type == 1 || item.food_type == 3
          : item.food_type == 1;
      } else if (isNonVegSelected) {
        foodTypeMatches = item.food_type == 2 || item.food_type == 3;
      }

      return searchMatches && foodTypeMatches;
    });

    setFilteredItems(filteredList);

  }, [searchitem, allProductsList, isVegSelected, isNonVegSelected, isEggSelected]);


  const openAddonModal = (productid, item) => {
    addonModalRef.current.classList.add("show");
    addonModalRef.current.style.display = "block";
    setLoadingButtonId(productid)
    setProductid(productid)
    setMenuOpen(false)
    setModelOpen(false)
    if (!serarchModal) {

      setIsModalOpen(true)
    }
  };

  const closeAddonModal = () => {
    addonModalRef.current.classList.remove("show");
    addonModalRef.current.style.display = "none";
    setMenuOpen(true)
    if (!serarchModal) {

      setIsModalOpen(false)
    }
  };

  const openEditAddonModal = (item, addons) => {

    let transformedData = transformDataAndCalculateTotalCost(item, addons);

    setProductid(item.product_id);
    addonEditeModalRef.current.classList.add("show");
    addonEditeModalRef.current.style.display = "block";
    setModelOpen(false)
    setMenuOpen(false)
    if (!serarchModal) {
      setIsModalOpen(true)
    }
    setSelectedAddons(transformedData.addons);
    const matchedProduct = cartproduct.find((product) => product.product_id == item.product_id);

    if (matchedProduct) {

      setProductpriceTotal(matchedProduct.price);
    } else {
      setProductpriceTotal(0);
    }
  };

  const closeEditAddonModal = () => {
    addonEditeModalRef.current.classList.remove("show");
    addonEditeModalRef.current.style.display = "none";
    setMenuOpen(true)
    if (!serarchModal) {
      setIsModalOpen(false)
    }
  };



  const handelEdittoAddonmodel = (productid) => {
    closeEditAddonModal()
    openAddonModal()
    setModelOpen(false)
    setProductid(productid)
    setProductCost((productpriceTotal) * (productCount))
  }


  // const transformDataAndCalculateTotalCost = (rawData, selectedOptions) => {
  //   let transformedData = [];
  //   let totalCost = 0; 

  //   if (rawData && rawData.length > 0) {
  //     rawData.forEach((addon) => {
  //       let addonObj = { addonId: addon.id, options: [] };

  //       addon?.options?.forEach((option) => {
  //         if (selectedOptions?.includes(option)) {
  //           addonObj.options?.push(option?.id);
  //           totalCost += parseInt(option?.price, 10);
  //         }
  //       }); 

  //       if (addonObj.options.length > 0) {
  //         transformedData.push(addonObj);
  //       }
  //     });
  //   }

  //   return { addons: transformedData, cost: totalCost };
  // };

  const transformDataAndCalculateTotalCost = (rawData, selectedOptions) => {
    let transformedData = [];
    let totalCost = 0;

    const selectedIds = selectedOptions || [];


    if (Array.isArray(rawData.addons) && rawData.addons.length > 0) {
      rawData.addons.forEach((addon) => {
        let addonObj = {
          addonId: addon.addon_id,
          product_id: addon.product_id,
          options: []
        };


        addon?.options?.forEach((option) => {
          const optionId = option.id;

          if (selectedIds.some((id) => Number(id) === Number(optionId))) {
            addonObj.options.push({
              optionId: option.id,
              name: option.name,
              type: option.type,
              price: option.price
            });

            totalCost += Number(option.price);
          }
        });


        if (addonObj.options.length > 0) {
          transformedData.push(addonObj);
        }
      });
    }

    return { addons: transformedData, cost: totalCost };
  };

  const checkIsSelectedAddon = (addonId, optionId) => {
    const selectedAddon = selectedAddons.find(item => item.addonId == addonId);
    return selectedAddon?.options.some(opt => opt.optionId == optionId) || false;
  };


  const checkButtonStatus = () => {
    if (!Array.isArray(selectItem?.addons)) {
      return;
    }

    for (const addon of selectItem.addons) {
      const selectedAddon = selectedAddons?.find((sel) => sel?.addonId == addon?.addon_id);
      const selectedOptionsCount = selectedAddon ? selectedAddon?.options?.length : 0;

      if (addon?.required == 1 && addon?.selection_type == 2 && selectedOptionsCount < Math.max(1, Number(addon.min_select) || 0)) {
        toast(`You need to select at least ${Math.max(1, Number(addon.min_select) || 0)} option(s) from the category ${addon?.addon_name}`,
          {
            position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: false,
            progress: undefined, theme: "light", className: 'text-danger toast-style-1 toast-custom-style'
          });
        return;
      } else if (addon?.required == 1 && addon?.selection_type == 1 && selectedOptionsCount <= 0) {
        toast(`You need to select at least 1 option(s) from the category ${addon?.addon_name}`,
          { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: false, progress: undefined, theme: "light", className: 'text-danger toast-style-1 toast-custom-style' });
        return;
      }
    }

    closeAddonModal();
    // closeEditAddonModal(); 

    setModelOpen(true);

    Add_Remove_productcount(selectItem, 'add')
    // action_productcount(selectItem, "add", selectedAddons);

  };


  const confirmUpdate = (item) => {
    setModelOpen(true)
    closeEditAddonModal()
    Add_Remove_productcount(item, 'add')

  }

  useEffect(() => {
    if (productsAddons && productsAddons.length > 0) {
      const mergedProducts = productsList.map((product) => {
        let addonsList = productsAddons.filter((addon) => addon.product_id == product.product_id);


        return {
          ...product,
          addons: addonsList,
          addons_status: addonsList.length > 0
        };
      });
      setProductsList(mergedProducts);
    }
  }, [productsAddons])

  useEffect(() => {
    if (productsList && productsList.length > 0) {
      const mergedCategories = productsCategories.map((category) => {
        const categoryProducts = productsList.filter((product) => { return product.category_id == category.id }).map((product) => {
          let updatedProduct = { ...product };

          if (cardStatus == 1) {
            const { discount_type, discount } = cardDetails || {};
            const originalPrice = updatedProduct.price;

            let discountAmount = 0;
            if (discount_type == 1) {
              discountAmount = discount;
            } else if (discount_type == 2) {
              discountAmount = Math.round((discount / 100) * originalPrice);
            }
            const newPrice = originalPrice - discountAmount;
            const benefitType = "discount";
            const benefitLabel = discount_type == 1 ? `₹${discount} ${benefitType} applied` : `${discount}% ${benefitType} applied`;
            updatedProduct = {
              ...updatedProduct,
              applied_card_type: cardType,
              applied_card_status: cardStatus,
              cardDetails,
              benefit: discount,
              benefit_lable: benefitLabel,
              price: originalPrice,
              original_price: originalPrice,
            };
          }

          return updatedProduct;
        });


        return {
          id: category.id,
          label: category.label,
          products: categoryProducts,
          numberOfProducts: categoryProducts.length,
          isOpen: true
        };
      });

      setMergedProductsRaw(mergedCategories);
      setMergedProducts(mergedCategories);

    }
    setTimeout(() => {
      setPageLoaded(true);
    }, 2000);
  }, [productsList])

  useEffect(() => {
    if (productsList && productsList.length > 0) {
      const categoryProducts = productsList.map((product) => {
        let updatedProduct = { ...product };

        if (cardStatus == 1) {
          const { discount_type, discount } = cardDetails || {};
          const originalPrice = updatedProduct.price;

          let discountAmount = 0;
          if (discount_type == 1) {
            discountAmount = discount;
          } else if (discount_type == 2) {
            discountAmount = Math.round((discount / 100) * originalPrice);
          }
          const newPrice = originalPrice - discountAmount;
          const benefitType = "discount";
          const benefitLabel = discount_type == 1 ? `₹${discount} ${benefitType} applied` : `${discount}% ${benefitType} applied`;
          updatedProduct = {
            ...updatedProduct,
            applied_card_type: cardType,
            applied_card_status: cardStatus,
            cardDetails,
            benefit: discount,
            benefit_lable: benefitLabel,
            price: newPrice,
            original_price: originalPrice,
          };
        }
        return updatedProduct;
      });
      setAllProductsList(categoryProducts);
    }
  }, [productsList])

  useEffect(() => {
    const isReadyToCall =
      valueParam?.vendor_id &&
      shipingtype != undefined &&
      cardStatus != undefined &&
      cardType != undefined &&
      cardId != undefined;
    console.log('isReadyToCall---', isReadyToCall);

    if (isReadyToCall) {
      getVendorStatuses();
      getVendorProductsCategories();
      let cart_items = localStorage.getItem("cart_items") ? JSON.parse(localStorage.getItem("cart_items")) : "";
      const localcart_items = cart_items?.cart_items;
      setCartproduct(localcart_items);
    }
  }, [valueParam?.vendor_id, shipingtype, cardStatus, cardType, cardId]);


  const getVendorStatuses = async () => {
    try {
      let reqData = {
        vendor_id: valueParam.vendor_id
      }
      const response = await getVendorProfileDetails(reqData);
      if (response.status == 200) {
        const data = response.data;

        setVendorType(data?.vendor_profile?.vendor_details?.vendor_type_id);
      }
    }
    catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      }
    }
  }

  const getVendorProductsCategories = async () => {
    try {
      const payload = {
        vendor_id: valueParam.vendor_id
      };

      const response = await fetchVendorProductCategoriesList(payload);
      if (response?.status == 200) {
        const responseData = response?.data;

        const categories = responseData?.categories?.map((category) => ({
          id: category.category_id,
          label: category.category_name,
          products: [],
          numberOfProducts: 0
        })) || [];

        setProductsCategories(categories);

        if (valueParam?.vendor_id && shipingtype !== undefined) {
          getVendorProducts(1);
        } else {
        }
      }
    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      }
    }
  };


  const getVendorProducts = async (pageNumber = 1) => {
    try {
      const payload = {
        vendor_id: valueParam.vendor_id,
        page: pageNumber,
        shipping_type: shipingtype,
        card_status: cardStatus,
        card_type: cardType,
        card_id: cardId,
        cart_id: cartId,
      };


      const response = await vendorProductsList(payload);

      if (response?.status == 200) {
        const responseData = response?.data;

        if (cardStatus == 1 && responseData?.card_details) {
          setCardDetails(responseData.card_details);
          setCard(responseData.card_details)
        }

        if (Array.isArray(responseData?.products) && responseData.products.length > 0) {
          setProductsList((prevData) => {
            const validPrevData = Array.isArray(prevData) ? prevData : [];
            const newProducts = responseData.products.filter(
              (product) => !validPrevData.some((existingProduct) => existingProduct.product_id == product.product_id)
            );
            return [...validPrevData, ...newProducts];
          });
        }

        const currentPage = Number(responseData?.current_page || 1);
        const totalPages = Number(responseData?.total_pages || 1);
        setTotalPagesCount(totalPages);

        // if (currentPage < totalPages) {
        fetchNextPageInBackground(currentPage + 1);
        // }

      }
    } catch (error) {
      if (error?.response) {
        const { status, data } = error.response;

        const message = status == 400 ? data?.message || "Bad request." : "Something went wrong. Please try again.";

        toast(message, {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          theme: "light",
          className: "text-danger toast-style-1",
        });
      } else {
        console.error("API Error:", error);
      }
    }

    //   setPageLoaded(true);

  };


  const fetchNextPageInBackground = async (nextPage) => {
    try {

      const payload = {
        vendor_id: valueParam.vendor_id,
        page: nextPage,
        shipping_type: shipingtype,
        card_status: cardStatus,
        card_type: cardType,
        card_id: cardId,
        cart_id: cartId,
      };

      const response = await vendorProductsList(payload);

      if (response?.status == 200) {
        fetchProductsAddons();

        const responseData = response?.data;

        if (
          responseData.current_page >= responseData.total_pages ||
          !Array.isArray(responseData.products) ||
          responseData.products.length == 0
        ) {

          return;
        }

        setProductsList((prevData) => {
          const validPrevData = Array.isArray(prevData) ? prevData : [];
          const newProducts = responseData.products.filter(
            (product) =>
              !validPrevData.some(
                (existingProduct) => existingProduct.product_id === product.product_id
              )
          );
          return [...validPrevData, ...newProducts];
        });

        setMenuLoaded(true);
      }
    } catch (error) {
      console.error("Background Fetch Error:", error);
    }
  };


  const fetchProductsAddons = async () => {
    try {
      const payload = {
        vendor_id: valueParam.vendor_id,
      };

      const response = await vendorProductsAddonList(payload);
      if (response?.status == 200) {
        const responseData = response?.data;
        // the API returns the flat add-on list under `addons` (one entry per product and group)
        setProductsAddons(responseData?.addons || []);
      }
    } catch (error) {
      console.error("Background Fetch Error:", error);
    }
  };

  // const handleReviewAndPay = (page) => {
  //   const flowtypeValue = flowtype == "EDIT_ORDER" ? "EDIT_ORDER" : flowtype;

  //   if (card?.offer_type == "4") {
  //     if (card?.combo_count != cardCount) {
  //       return toast(`    You should select ${card?.combo_count} products only`, {
  //         position: "bottom-center",
  //         autoClose: 2000,
  //         hideProgressBar: true,
  //         className: "text-danger toast-style-1",
  //       });
  //     }
  //     return page == 'basket' ?
  //       navigate("/productBasket", {
  //         state: { merchantId, cartId, flowtype, offer_type: card?.offer_type, offer_count: card?.combo_count }
  //       }) :
  //       navigate("/ReviewPay", { state: { merchantId, cartId, shipingtype, flowtype: flowtypeValue } });
  //   }
  //   if (card?.min_qty_status == "1" && card?.min_quantity > totalproductCount) {
  //     return toast(`This offer requires a minimum purchase of  ${card?.min_quantity} items`, {
  //       position: "bottom-center",
  //       autoClose: 2000,
  //       hideProgressBar: true,
  //       className: "text-danger toast-style-1",
  //     });
  //   }
  //   else if (card?.min_pur_status == "1" && card?.min_pur_amount > Number(totalAmount)) {


  //     return toast(`A minimum purchase value of ₹ ${card?.min_pur_amount} is required to use this offer.`, {
  //       position: "bottom-center",
  //       autoClose: 2000,
  //       hideProgressBar: true,
  //       className: "text-danger toast-style-1",
  //     });
  //   }

  //   return page == 'basket' ?
  //     navigate("/productBasket", {
  //       state: { merchantId, cartId, flowtype, offer_type: card?.offer_type, offer_count: card?.combo_count }
  //     }) :
  //     navigate("/ReviewPay", { state: { merchantId, cartId, shipingtype, flowtype: flowtypeValue } });
  // };



  const handleReviewAndPay = (page) => {
    const flowtypeValue = flowtype == "EDIT_ORDER" ? "EDIT_ORDER" : flowtype;

    if (card?.offer_type == "4") {
      if (card?.combo_count != cardCount) {
        toast(`Please select exactly  ${card?.combo_count} products to continue.`, {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          className: "text-danger toast-style-1",
        });
        return;
      }

      if (page == 'basket') {
        navigate("/productBasket", {
          state: { merchantId, cartId, flowtype, offer_type: card?.offer_type, offer_count: card?.combo_count }
        });
      } else {
        navigate("/ReviewPay", {
          state: { merchantId, cartId, shipingtype, flowtype: flowtypeValue }
        });
      }
      return;
    }

    if (card?.min_qty_status == "1" && card?.min_quantity > totalproductCount) {
      toast(`This offer requires a minimum purchase of ${card?.min_quantity} items`, {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: true,
        className: "text-danger toast-style-1",
      });
      return;
    }

    if (card?.min_pur_status == 1 && card?.min_pur_amount > Number(totalAmount)) {
      toast(`A minimum purchase value of ₹${card?.min_pur_amount} is required to use this offer.`, {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: true,
        className: "text-danger toast-style-1",
      });
      return;
    }

    if (page == 'basket') {
      navigate("/productBasket", {
        state: { merchantId, cartId, flowtype, offer_type: card?.offer_type, offer_count: card?.combo_count }
      });
    } else {
      navigate("/ReviewPay", {
        state: { merchantId, cartId, shipingtype, flowtype: flowtypeValue }
      });
    }
  };


  return (
    <>
      <div>
        <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white ">
          <div className="d-flex justify-content-between align-items-center ms-2 me-2">
            <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button"
              onClick={() => {
                flowtype == "EDIT_ORDER" ?
                  navigate(`/ProductPass/${cartId}`, { state: { orderid: cartId, flowtype: "EDIT_ORDER" } }) :
                  cardStatus == "1" ? navigate(-1) :
                    flowtype == 'NewSearch' || flowtype == 'addItems' ?
                      navigate(-1) :
                      navigate(`/vendor/${valueParam.vendor_id}`);
              }} />
            <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">Products</div>
          </div>
          {cardCount > 0 ? (
            <div onClick={() => navigate("/productBasket", {
              state: { merchantId, cartId, flowtype, offer_type: card?.offer_type, offer_count: card?.combo_count }
            })} style={{ cursor: "pointer" }} >
              <img src={ion_cart_outline} />
              <div className="basketCount">
                {cardCount > 0 ? (
                  <span style={{
                    height: "20px", width: "20px", backgroundColor: "var(--primary-bg)", color: "white", borderRadius: "50%",
                    display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center",
                  }} >
                    {cardCount}
                  </span>
                ) : (cardCount > 0 && <span>{cardCount}</span>)}
              </div>
            </div>
          ) : (
            <div>
              <img src={ion_cart_outline} />
            </div>
          )}
        </div>
      </div>
      {
        pageLoaded ?
          <>
            <div className="scroller-style-y">
              <div className="mt-2 p-2 d-none" >
                <div className="d-flex justify-content-between deleiveryAddress rounded-pill bg-white secondary-text-1 p-1">
                  <input type="text" className="SearchServiceBox ms-2 custom-input ff-balooPaaji2-regular rounded-pill fs-14 mt-1"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.target.blur();
                      }
                    }} placeholder="Search " />

                </div>
              </div>
              <div className=" ">
                <div className="mt-2 p-2 " onClick={() => openserachProductModal()}>
                  <div className="d-flex justify-content-between deleiveryAddress rounded-pill bg-white secondary-text-1 p-1 custom-input">
                    <input type="text" onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.target.blur();
                      }
                    }} className="SearchServiceBox custom-input ms-2  ff-poppins-regular rounded-pill fs-14 mt-1" placeholder="Search " />
                    <span className="me-3"> <IoSearch /> </span>
                  </div>
                </div>
                {
                  vendorType == "9" ?
                    <div className="d-flex fs-13 ff-poppins-semiBold mb-2 p-2">
                      <div className="d-flex ms-2" onClick={handleVegToggle}>
                        <span>Veg</span>
                        <Toggle data={vegIcon} color="veg" isSelected={isVegSelected} />
                      </div>
                      {
                        isVegSelected ? <div className="d-flex" onClick={handleEggToggle}>
                          <span>Egg</span>
                          <Toggle data={eggIcon} color="egg" isSelected={isEggSelected} />
                        </div> : ""
                      }
                      <div className="d-flex" onClick={handleNonVegToggle}>
                        <span>Non-veg</span>
                        <Toggle data={nonvegIcon} color="nonveg" isSelected={isNonVegSelected} />
                      </div>

                    </div> : ""
                }

              </div>
              {mergedProducts?.length > 0 ? (
                <div className="offcanvas-parentType3" id="scroll" onClick={closeMenuList}>
                  <div className="doorStepService p-0 position-relative" >
                    <div className="scroller-style-y">
                      <div className="accordion px-3  margin_bottom_250 ">
                        {

                          mergedProducts?.map((product, index) => {

                            return product?.products?.length > 0 ? (
                              <div className="">
                                <div className="accordion-item product_list_accordion " key={index} >
                                  <h2 className="accordion-header gap-0 row-gap-3 mb-1" id={"collapseOne" + index}>
                                    <button className={`serviceMenu-but p-2 m-0 accordion-button ff-poppins-bold fs-16 text-white ${isItemOpen(index) ? "" : "collapsed"
                                      }`} type="button" onClick={() => toggleAccordion(index)} aria-expanded={isItemOpen(index) ? "true" : "false"}   >
                                      <p className="m-0"> {product.label} </p>
                                      <p className="m-0">
                                        {isItemOpen(index) ? (<IoIosArrowUp style={{ fontSize: 20 }} />) : (<IoChevronDown style={{ fontSize: 20 }} />)}
                                      </p>
                                      <style>{`button::after {   display: none;  position: absolute;   content: '';   }`}  </style>
                                    </button>
                                  </h2>
                                  <div className={`accordion-collapse collapse ${isItemOpen(index) ? "show" : ""}`} aria-labelledby={"heading" + index}  >
                                    <div className="accordion-body">
                                      {
                                        product?.products.map((item, itemIndex) => {

                                          console.log('itemitemIndex', itemIndex, item);

                                          return (

                                            <div key={itemIndex} >
                                              <div>
                                                <div className={`${item.stock_status == 1 && item.stock_quantity == 0 ? 'opacity_5 productDiv' : " productDiv"}`}>
                                                  <div className="col-3 ">
                                                    <div className="imgBox position-relative productImageDiv">
                                                      <img
                                                        src={item?.imges?.[0]?.image_url || defaultimg}
                                                        className="productImage"
                                                        onError={(e) => (e.currentTarget.src = defaultimg)}
                                                      />

                                                    </div>
                                                  </div>
                                                  <div className="col-9">
                                                    <div className=" ms-1">
                                                      <div className="d-flex align-item-center">
                                                        {vendorType == "9" &&
                                                          <img src={item.food_type == "1" ? vegIcon : item.food_type == "2" ? nonvegIcon : item.food_type == "3" ? eggIcon : ""} className="food-type-icon" />
                                                        }
                                                        <span className="ff-poppins-semiBold fs-12"> {item.product_name} </span>
                                                      </div>

                                                      <div>
                                                        {item?.applied_card_status == "1" && item?.cardDetails?.discount ? (
                                                          <div className="ff-poppins-medium fs-12 me-1 m-0">
                                                            <span className="rupeeIcon ">₹</span>{item.price}{" "}
                                                            <span className="primary-text fs-11 ff-poppins-regular"> {item.benefit ? ('(' + item.benefit_lable + ')') : ''} </span>
                                                          </div>
                                                        ) : (
                                                          <div className="ff-poppins-medium fs-12 d-flex me-1 ">
                                                            <span className="rupeeIcon ">₹</span>{item.price}{" "}
                                                          </div>
                                                        )}
                                                      </div>
                                                      <div className="ff-poppins-semiBold primary-text fs-9">
                                                        {item.unit_quantity} {item.unit_type_name}
                                                      </div>

                                                      <div className="moreDetailsDiv primary-text">
                                                        <p className="moreInfobtn ff-poppins-semiBold fs-10 px-0 m-0"
                                                          onClick={() => navigate(`/product/${merchantId}/${item.product_id}`, { state: { productId: item.product_id, merchantId } })}  >
                                                          More details
                                                        </p>
                                                        <IoIosArrowDown className="fw-bold productWeightBasket " />
                                                      </div>


                                                      <div className={`d-flex ${item.stock_status ? 'justify-content-between' : 'justify-content-end'}`} >
                                                        <div>
                                                          {item?.stock_status == "1" ? (
                                                            item?.stock_quantity == 0 ?
                                                              <span className="text-danger fs-10 p-0 m-0 ff-poppins-semiBold"> Out of stock</span> :
                                                              cartproduct &&
                                                                cartproduct?.filter((product) => product?.product_id == item?.product_id).length > 0 ? (
                                                                cartproduct?.filter((product) => product?.product_id == item?.product_id)
                                                                  .map((product) => (
                                                                    <div key={product?.product_id}>
                                                                      <p className="ff-poppins-semiBold primary-text fs-9 m-0">
                                                                        {item?.stock_quantity - (product?.quantity)} left
                                                                      </p>
                                                                    </div>
                                                                  ))
                                                              ) : (
                                                                <div key={item.product_id}>
                                                                  <p className="ff-poppins-semiBold primary-text fs-9 m-0">
                                                                    {item?.stock_quantity} left
                                                                  </p>
                                                                </div>
                                                              )
                                                          ) : (
                                                            ""
                                                          )}

                                                        </div>
                                                        <div className="  d-flex justify-content-center align-items-end primary-text">
                                                          <div className="ff-poppins-regular fs-9 primary-text" >
                                                            {
                                                              (() => {

                                                                const productAction = cartproduct?.find(action => action.product_id == item.product_id);
                                                                return productAction ? (
                                                                  productAction.quantity != 0 ? (
                                                                    <div>
                                                                      <div className="row align-items-center w-100 fs-14 gx-0">
                                                                        <div className="col-4">
                                                                          <FiMinusCircle
                                                                            className="w-100 primary-text fontSizeCountIcon"
                                                                            // onClick={() => action_productcount(item, "remove")}
                                                                            onClick={() => Add_Remove_productcount(item, 'remove', 1)}
                                                                          />
                                                                        </div>
                                                                        <div className="col-4 d-flex justify-content-center align-items-end primary-text">
                                                                          {productAction.quantity}
                                                                        </div>
                                                                        <div className="col-4">
                                                                          <LiaPlusCircleSolid
                                                                            className={`w-100 primary-text fontSizeCountIcon ${card?.offer_type == "4" ? productAction.quantity == "1" ? "opacity_Cls rounded-circle" : ""
                                                                              : productAction.quantity == item.max_allowed_quantity || productAction.quantity == item.stock_quantity ? "opacity_Cls rounded-circle" : ""}`}
                                                                            onClick={() => {
                                                                              setSelectItem(item);
                                                                              if (item.max_allowed_status == 1 && productAction.quantity == item.max_allowed_quantity) {
                                                                                showToast('You have reached maximum order product')
                                                                                return;
                                                                              }
                                                                              else if (item.stock_status == 1 && productAction.quantity == item.stock_quantity) {
                                                                                showToast('No more stock left for this product')
                                                                                return;
                                                                              }
                                                                              else if (card?.offer_type == "4") {
                                                                                if (productAction.quantity == "1") {
                                                                                  // showToast('You have reached maximum order product')
                                                                                }
                                                                              }
                                                                              else if (!item.addons || item.addons == '') {
                                                                                Add_Remove_productcount(item, 'add', 1)
                                                                                setProductCount(productAction.quantity);

                                                                              } else if (item.addons) {
                                                                                setSelectItem(item)
                                                                                setProductCount(productAction.quantity)
                                                                                openEditAddonModal(item, productAction.addons);
                                                                              }
                                                                              else if (card?.offer_type == "1") {
                                                                                // action_productcount(item, "add");
                                                                                Add_Remove_productcount(item, 'add', 1)
                                                                              }
                                                                            }} />
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  ) : null
                                                                ) : (
                                                                  <div className="col-4  selectBtnProductDiv" >
                                                                    <button
                                                                      className={`selectBtnProduct primary-text fs-12 ff-poppins-semiBold ${loadingButtonId === item.product_id ? "loading" : ""
                                                                        }`}
                                                                      onClick={() => {
                                                                        if (card?.offer_type == "4" && cardCount >= card?.combo_count) {
                                                                          showToast(`You can select only ${card?.combo_count} products for this offer.`);
                                                                          return;
                                                                        }
                                                                        if (item?.addons_status) {
                                                                          openAddonModal(item?.product_id, item);
                                                                        } else {
                                                                          handleClick(item.product_id, item);
                                                                        }
                                                                        setProductCost(item?.price);
                                                                        setSelectItem(item);
                                                                        setProductCount(1);
                                                                      }}
                                                                    >
                                                                      <span>Select</span>
                                                                    </button>
                                                                  </div>
                                                                );
                                                              })()
                                                            }
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            // <ProductCard data={item} />
                                          );
                                        })
                                      }
                                      <></>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : null;
                          })

                        }
                      </div>
                    </div>

                    {isModelOpen && !serarchModal && (
                      <div className="productsHeroDiv" style={{ zIndex: 9992 }} >
                        {
                          cardCount && (
                            <div className="reviewPayDivs" >
                              <div className="linetop-container" >
                                <div className="lineTop text-center primary-text" style={{ borderTop: "3px solid" }}   >

                                </div>
                              </div>
                              <div className="d-flex ff-poppins-bold">
                                <div className="primary-text d-flex mb-2">
                                  <span className="me-1  ms-1">  {cardCount > 1 ? cardCount + " Products" : cardCount + " Product"}</span>
                                  <span className="text-dark">added</span>{" "}
                                </div>
                              </div>
                              <button className='primary-bg reviewAndPayBtnProduct ff-balooPaaji2-bold '
                                onClick={() => handleReviewAndPay()}    >
                                {
                                  btnLoading ?
                                    <div className="d-flex justify-content-center">
                                      <div class="spinner-border mt-1 text-light" role="status" style={{ height: "20px", width: "20px" }} >
                                        <span class="visually-hidden">Loading...</span>
                                      </div>
                                    </div>
                                    :
                                    "Review and Pay"
                                }
                              </button>


                            </div>
                          )
                        }
                      </div>
                    )}


                    {isMenuOpen && (
                      <div className="menu-div">
                        <div className="left-div"></div>
                        <div className="right-div">
                          <div className="dropup-center dropup" style={{ zIndex: 9990 }}>

                            <button id="menuButton" className="btn btn-secondary dropdown-toggle menuBtn" type="button" onClick={dropUpMenuPress} style={{ display: showMenus ? "none" : " ", }} >
                              <RxHamburgerMenu className="menuIcon" />
                              Menu
                            </button>

                          </div>
                        </div>
                        {showMenus && (
                          <>
                            <div className="backdrop" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 9991 }} onClick={(e) => { e.stopPropagation(); setShowMenus(false) }}></div>
                            <div className="menu-list-container">
                              <ul className="dropdown-menu show scroller-style-y rounded-4" style={{ maxHeight: "200px" }} id="menuList"  >
                                {mergedProducts.map((cate, index) => (
                                  cate.products?.length > 0 ?
                                    <li key={index} className="d-flex justify-content-between p-1 fs-12 ff-poppins-regular">
                                      <button className="dropdown-item d-flex collapsed justify-content-between" onClick={() => handleCategoryClick(index)} >
                                        <span className="truncate-text">{cate.label}</span>
                                      </button>
                                      <span className="me-1 text-light">{cate.numberOfProducts}</span>
                                    </li> : ""
                                ))}

                              </ul>
                            </div>
                          </>
                        )}
                      </div>)}

                  </div>
                </div>
              ) :
                (
                  <>
                    <div>
                      <Lottie animationData={empotyLottie} />
                    </div>
                    <p className='text-dark text-center mt-5 ff-balooPaaji2-bold fs-20 '>No Product Available</p>

                  </>
                )}

              {/* Edit addon madal */}

              <div className="offcanvas addOnModalOffcancas" tabIndex="-1" ref={addonEditeModalRef} >
                <div className=" d-flex justify-content-end mt-1" onClick={() => closeEditAddonModal()}>
                  <div className="fs-20 ff-poppins-semiBold me-2 crossContainer" ><CgClose /> </div>
                </div>

                <div className=" insideAddon" >
                  <div className="editAddonTitleCont addOnModel_scroll">
                    <div className="editAddonTitle">Your Addons</div>
                    <div className="editaddonBtn" onClick={() => handelEdittoAddonmodel(productid)}>Edit</div>
                  </div>
                  <div className="addonProductListCont" style={{ margin: '19px 0px' }}>
                    {cartproduct?.length > 0 &&
                      cartproduct.map((product, productIndex) => {
                        return (
                          productid == product?.product_id &&
                          Array.isArray(product?.addons) &&
                          product.addons.map((optionId, optionIndex) => {
                            const matchedAddonGroup = productsAddons?.find(
                              (pa) =>
                                pa.product_id == product.product_id &&
                                pa.options?.some((opt) => opt.id == optionId)
                            );
                            const matchedOption = matchedAddonGroup?.options?.find(
                              (opt) => opt.id == optionId
                            );

                            return (
                              matchedOption && (
                                <div
                                  className="addonProductCont"
                                  key={`${productIndex}-${optionIndex}`}
                                  style={{ margin: "0px 0px" }}
                                >
                                  <div className="addonProductLeft">
                                    {(matchedOption?.type == "1" || matchedOption?.type == "2") && (
                                      <img
                                        src={matchedOption?.type == "1" ? vegIcon : nonvegIcon}
                                        height="13px"
                                        width="13px"
                                      />
                                    )}
                                    <div className="addonProductName">{matchedOption?.name}</div>
                                  </div>
                                  <div className="addonProductRight">
                                    <div className="addonPrice ff-poppins-regular" style={{ lineHeight: "16px" }}>
                                      +&nbsp;<span className="rupeeIcon">₹</span>
                                      {matchedOption?.price}
                                    </div>
                                  </div>
                                </div>
                              )
                            );
                          })
                        );
                      })}
                  </div>

                  <div className="mt-3" style={{ backgroundColor: '#fff', position: "sticky", bottom: 0, width: '100%' }}>
                    <div className=" ">
                      {cartproduct?.length > 0 &&
                        cartproduct?.map((item) => (
                          <div className="ff-poppins-regular ">
                            {productid == item?.product_id && item?.quantity > 0 && (
                              <div>
                                <div className="d-flex justify-content-between">
                                  <div className="  d-flex fs-14 col-4  ">
                                    <div className="col-2">
                                      <FiMinusCircle
                                        className="primary-text fontSizeCountIcon"
                                        onClick={() => {
                                          setProductCount((prevCount) => {
                                            const newCount = Math.max(prevCount - 1, 0);
                                            if (newCount == 0) {
                                              Add_Remove_productcount(item, 'remove', 1)
                                              setSelectedAddons([]);
                                              closeEditAddonModal()
                                            }
                                            return newCount;
                                          });
                                        }}
                                      />
                                    </div>
                                    <div className="col-2 ms-1 d-flex justify-content-center">
                                      {productCount}
                                    </div>

                                    <div className="col-2">
                                      <LiaPlusCircleSolid
                                        className={`primary-text fontSizeCountIcon ${card?.offer_type == "4"
                                          ? Number(selectItem?.quantity) >= Number(card?.combo_count)
                                            ? "opacity_Cls rounded-circle"
                                            : ""
                                          : productCount >= Number(selectItem.max_allowed_quantity || Infinity) ||
                                            productCount >= Number(selectItem.stock_quantity)
                                            ? "opacity_Cls rounded-circle"
                                            : ""
                                          }`}


                                        onClick={() => {
                                          const maxQty = selectItem.max_allowed_quantity ? Number(selectItem.max_allowed_quantity) : Infinity;
                                          const stockQty = Number(selectItem.stock_quantity);
                                          const addedCount = Number(item.quantity);

                                          if (card?.offer_type == "4") {
                                            if (addedCount < Number(card?.combo_count)) {
                                              setProductCount((prevCount) => prevCount + 1);
                                              setProductid(item.product_id);
                                            } else {
                                              showToast(`You can select only ${card?.combo_count} products for this offer.`);
                                            }
                                          } else {
                                            if (productCount >= stockQty) {
                                              showToast("No more stock left for this product");
                                            } else if (productCount >= maxQty) {
                                              showToast("You have reached maximum order product");
                                            } else {
                                              setProductCount((prevCount) => prevCount + 1);
                                              setProductid(item.product_id);
                                              setProductCost(productpriceTotal * (addedCount + 1));
                                            }
                                          }
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className=" p-1  ">
                                    <p className="m-0 d-flex justify-content-end primary-text ff-poppins-semiBold fs-14 mb-1 ">
                                      Cost : &nbsp;<span className="rupeeIcon "> ₹ </span> {(productpriceTotal) * (productCount)}
                                    </p>
                                  </div>

                                </div>
                                <div className="col-12">
                                  <button type="button" className="btn-type-1   ff-poppins-semiBold mt-2 fs-14 w-100 primary-bg border-0 text-white justify-content-center d-flex align-items-center"
                                    onClick={() => confirmUpdate(item)} >
                                    Confirm
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        ))
                      }
                    </div>
                  </div>
                </div>
              </div>

              {/* Add addon madal */}

              <div className="offcanvas addOnModalOffcancas" tabIndex="-1" ref={addonModalRef} >
                <div className=" d-flex justify-content-end mt-1" onClick={() => { closeAddonModal(); setSelectedAddons([]) }}>
                  <div className="fs-20 ff-poppins-semiBold me-2 crossContainer" ><CgClose /> </div>
                </div>

                <div className="insideAddon  " >
                  <div className="addonContainer addOnModel_scroll">
                    {productsAddons?.length > 0 &&
                      productsAddons?.map((product, productIndex) =>
                      (productid == product?.product_id ?
                        <div className="AddonCategoryCont" key={productIndex} >
                          <div className="addonCatgoryContTop">
                            <div className="addonCategoryTitle">Choose {product?.addon_name}</div>
                            <div className="addonCategorySubtitle">Select any (Optional)</div>
                          </div>
                          <div className="addonProductListCont">
                            {product?.options.map((option, optionIndex) => (
                              <div className="addonProductCont" key={`${productIndex}-${optionIndex}`}>
                                <div className="addonProductLeft">
                                  {(option?.type == "1" || option?.type == "2") && (
                                    <img src={option?.type == "1" ? vegIcon : option?.type == "2" ? nonvegIcon : ""} height="13px" width="13px" />
                                  )}
                                  <div className="addonProductName">
                                    {option?.name}
                                  </div>
                                </div>
                                <div className="addonProductRight" style={{ width: '130px' }}>
                                  <div className="addonPrice">+&nbsp;<span className="rupeeIcon">₹</span>{option?.price}</div>
                                  {
                                    checkIsSelectedAddon(product.addon_id, option.id) ?
                                      <FaSquareCheck size={18} onClick={() => { selectAddon(product, option.id, option?.price, option); setProductid(product?.product_id) }} className="checkBoxContainer" />
                                      :
                                      <FaRegSquare size={18} onClick={() => { selectAddon(product, option.id, option?.price, option); setProductid(product?.product_id) }} className="checkBoxContainer" />
                                  }
                                </div>
                              </div>

                            ))}
                          </div>
                        </div>
                        : "")
                      )}


                  </div>

                  <div style={{ backgroundColor: '#fff', position: "sticky", bottom: 0, width: '100%' }}>

                    <div className="">
                      <p className="m-0 d-flex justify-content-end primary-text ff-poppins-semiBold fs-14 mb-1 me-3">
                        Cost :&nbsp;<span className="rupeeIcon">₹</span> {productCost}  </p>
                      <button type="button" className="btn-type-1 ff-poppins-semiBold fs-14 col-12 primary-bg border-0 text-white justify-content-center d-flex align-items-center"
                        onClick={() => checkButtonStatus()} >
                        Confirm
                      </button>
                    </div>

                  </div>
                </div>

              </div>
              {serarchModal &&
                <div className="offcanvas p-1 show" tabindex="-1" style={{ height: '92vh', width: 390, zIndex: 9994, borderTopLeftRadius: "32px", borderTopRightRadius: "32px" }}   >

                  <div style={{ borderTopLeftRadius: "32px", borderTopRightRadius: "32px", marginTop: "14px", }} >
                    <div class=" d-flex justify-content-between  ms-2 me-2 mt-4">
                      <h1 class="ff-poppins-semiBold fs-16 mt-2" id="exampleModalLabel">
                        Search
                      </h1>
                      <button type="button" className="btn-close " aria-label="Close" onClick={() => { closeserachProductModal(); setSearchitem(""); }}></button>
                    </div>
                    <div className=" ms-2 me-2">
                      <div className="search secondary-text-1">
                        <div  >
                          <span className="primary-text ff-poppins-semiBold"> <IoSearch /> </span>
                          <input type="text" placeholder="Search products" onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.target.blur();
                            }
                          }} className="secondary-text-1 custom-input ff-poppins-regular fs-14" value={searchitem} onChange={(e) => setSearchitem(e.target.value)} />
                        </div>
                      </div>

                    </div>
                    {/* {
                      vendorType == "9" ?
                        <div className="d-flex fs-14 ff-poppins-semiBold   mt-2">
                          <div className="d-flex ms-2" onClick={handleVegToggle}>
                            <span>Veg</span>
                            <Toggle data={vegIcon} color="veg" isSelected={isVegSelected} />
                          </div>
                          {
                            isVegSelected ? <div className="d-flex" onClick={handleEggToggle}>
                              <span>Egg</span>
                              <Toggle data={eggIcon} color="egg" isSelected={isEggSelected} />
                            </div> : ""
                          }

                          <div className="d-flex" onClick={handleNonVegToggle}>
                            <span>Non-veg</span>
                            <Toggle data={nonvegIcon} color="nonveg" isSelected={isNonVegSelected} />
                          </div>

                        </div> :
                        ""
                    } */}
                    <div className="mt-2 ms-2">
                      <h6 className="ff-poppins-regular secondary-text-1">Products</h6>
                    </div>
                  </div>

                  <div>
                    <div className="padding_Bottom scroller-style-y">
                      {
                        filteredItems.length > 0 || searhModelItems.length > 0 ?
                          filteredItems?.map((item, itemIndex) => (
                            <div key={itemIndex} >
                              {/* <div className="productDiv shadow "> */}
                              <div className={`${item.stock_status == 1 && item.stock_quantity == 0 ? 'opacity_5 productDiv' : " productDiv"}`}>
                                <div className="col-3 ">
                                  <div className="imgBox position-relative productImageDiv ">
                                    <img src={(item.imges && item.imges.length > 0 && item.imges[0].image_url !== "") ? item.imges[0].image_url : defaultimg}
                                      className="productImage rounded-3" onError={(e) => (e.currentTarget.src = defaultimg)} />
                                  </div>
                                </div>
                                <div className="col-9">
                                  <div className="ms-1">
                                    <div className="d-flex align-items-center">
                                      {vendorType == "9" &&
                                        <img src={item.food_type == "1" ? vegIcon : item.food_type == "2" ? nonvegIcon : item.food_type == "3" ? eggIcon : ""} className="food-type-icon" />
                                      }
                                      <span className="ff-poppins-semiBold fs-12">{item.product_name}</span>
                                    </div>
                                    <div>
                                      {item?.applied_card_status == "1" && item?.cardDetails?.discount ? (
                                        <div className="ff-poppins-semiBold  fs-12 me-1 m-0">
                                          <span className="rupeeIcon ">₹</span>{item.price}{" "}
                                          <span className="primary-text fs-11 ff-poppins-regular"> {item.benefit ? ('(' + item.benefit_lable + ')') : ''} </span>
                                        </div>
                                      ) : (
                                        <div className="ff-poppins-semiBold  fs-12 me-1 m-0">
                                          <span className="rupeeIcon ">₹</span>{item.price}
                                        </div>
                                      )}
                                    </div>
                                    <div className="ff-poppins-semiBold primary-text fs-9">
                                      {item.unit_quantity} {item.unit_type_name}
                                    </div>

                                    <div className="moreDetailsDiv primary-text">
                                      <p className="moreInfobtn ff-poppins-semiBold fs-10 px-0 m-0"
                                        onClick={() => navigate(`/product/${merchantId}/${item.product_id}`, { state: { productId: item.product_id, merchantId } })}  >
                                        More details
                                      </p>
                                      <IoIosArrowDown className="fw-bold productWeightBasket " />
                                    </div>


                                    <div className={`d-flex ${item.stock_status ? 'justify-content-between' : 'justify-content-end'}`} >
                                      <div>
                                        {item?.stock_status == "1" ? (
                                          item?.stock_quantity == 0 ?
                                            <span className="text-danger fs-10 p-0 m-0 ff-poppins-semiBold"> Out of stock</span> :
                                            cartproduct &&
                                              cartproduct?.filter((product) => product?.product_id == item?.product_id).length > 0 ? (
                                              cartproduct?.filter((product) => product?.product_id == item?.product_id)
                                                .map((product) => (
                                                  <div key={product?.product_id}>
                                                    <p className="ff-poppins-semiBold primary-text fs-9 m-0">
                                                      {item?.stock_quantity - (product?.quantity)} left
                                                    </p>
                                                  </div>
                                                ))
                                            ) : (
                                              <div key={item.product_id}>
                                                <p className="ff-poppins-semiBold primary-text fs-9 m-0">
                                                  {item?.stock_quantity} left
                                                </p>
                                              </div>
                                            )
                                        ) : (
                                          ""
                                        )}

                                      </div>
                                      <div className="  d-flex justify-content-center align-items-end primary-text">
                                        <div className="ff-poppins-regular fs-9 primary-text" >
                                          {
                                            (() => {

                                              const productAction = cartproduct?.find(action => action.product_id == item.product_id);
                                              return productAction ? (
                                                productAction.quantity != 0 ? (
                                                  <div>
                                                    <div className="row align-items-center w-100 fs-14 gx-0">
                                                      <div className="col-4">
                                                        <FiMinusCircle
                                                          className="w-100 primary-text fontSizeCountIcon"
                                                          // onClick={() => action_productcount(item, "remove")}
                                                          onClick={() => Add_Remove_productcount(item, 'remove', 1)}
                                                        />
                                                      </div>
                                                      <div className="col-4 d-flex justify-content-center align-items-end primary-text">
                                                        {productAction.quantity}
                                                      </div>
                                                      <div className="col-4">
                                                        <LiaPlusCircleSolid
                                                          className={`w-100 primary-text fontSizeCountIcon ${card?.offer_type == "4" ? productAction.quantity == "1" ? "opacity_Cls rounded-circle" : ""
                                                            : productAction.quantity == item.max_allowed_quantity || productAction.quantity == item.stock_quantity ? "opacity_Cls rounded-circle" : ""}`}
                                                          onClick={() => {
                                                            setSelectItem(item);
                                                            if (item.max_allowed_status == 1 && productAction.quantity == item.max_allowed_quantity) {
                                                              showToast('You have reached maximum order product')
                                                              return;
                                                            }
                                                            else if (item.stock_status == 1 && productAction.quantity == item.stock_quantity) {
                                                              showToast('No more stock left for this product')
                                                              return;
                                                            }

                                                            else if (card?.offer_type == "4") {
                                                              if (productAction.quantity == "1") {
                                                                // showToast('You have reached maximum order product')
                                                              }
                                                            }
                                                            else if (!item.addons || item.addons == '') {
                                                              // action_productcount(item, "add");
                                                              Add_Remove_productcount(item, 'add', 1)
                                                            } else if (item.addons) {
                                                              setSelectItem(item)
                                                              setProductCount(productAction.quantity)
                                                              openEditAddonModal(item, productAction.addons);
                                                            }
                                                            else if (card?.offer_type == "1") {
                                                              // action_productcount(item, "add");
                                                              Add_Remove_productcount(item, 'add', 1)
                                                            }
                                                          }}
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                ) : null
                                              ) : (
                                                <div className="col-4  selectBtnProductDiv" >
                                                  <button
                                                    className={`selectBtnProduct primary-text fs-12 ff-poppins-semiBold ${loadingButtonId == item.product_id ? "loading" : ""
                                                      }`}
                                                    onClick={() => {
                                                      if (card?.offer_type == "4" && cardCount >= card?.combo_count) {
                                                        showToast(`You can select only ${card?.combo_count} products for this offer.`);
                                                        return;
                                                      }
                                                      if (item?.addons_status) {
                                                        openAddonModal(item?.product_id, item);
                                                      } else {
                                                        handleClick(item.product_id, item);
                                                      }
                                                      setProductCost(item?.price);
                                                      setSelectItem(item);
                                                      setProductCount(1);
                                                    }}
                                                  >
                                                    <span>Select</span>
                                                  </button>
                                                </div>
                                              );
                                            })()
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          ))
                          :
                          <div className=" ReactLoading">
                            <p className="p-5 text-center secondary-text-1 ff-poppins-regular fs-14"> No  Products  </p>
                          </div>
                      }
                    </div>
                  </div>

                  {/* </div> */}
                </div >
              }


              {isModalOpen && <div className="modal-backdrop fade show"></div>}

            </div>
            {/* {serarchModal && <div className="modal-backdrop fade show"></div>} */}



          </>
          :
          <div className='d-flex justify-content-center skeleton-bg'>
            <div >
              <Skeleton height={50} width={375} />
              <Skeleton height={90} width={375} />
              <Skeleton height={50} width={375} />
              <Skeleton height={90} width={375} />
              <Skeleton height={50} width={375} />
              <Skeleton height={90} width={375} />
              <Skeleton height={50} width={375} />
              <Skeleton height={90} width={375} />
            </div>
          </div>
      }

    </>
  );
};

export default Products;

